var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 30",
    style: {
      enableBackground: "new 0 0 35 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5A00CA;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,6C3.3,6,3,6.1,2.8,6.3C2.6,6.5,2.5,6.8,2.5,7V25c0,0.3,0.1,0.5,0.3,0.7C3,25.9,3.3,26,3.5,26h29 c0.3,0,0.5-0.1,0.7-0.3s0.3-0.5,0.3-0.7V7c0-0.3-0.1-0.5-0.3-0.7C33,6.1,32.8,6,32.5,6H3.5z M6.3,8.1h23.5L18,17.8L6.3,8.1z  M4.6,9.4l7.9,6.5l-7.9,6.8V9.4z M31.5,9.4v13.3l-7.9-6.8L31.5,9.4z M14.1,17.2l3.3,2.7c0.2,0.2,0.4,0.2,0.7,0.2 c0.2,0,0.5-0.1,0.7-0.2l3.3-2.7l7.8,6.7H6.3L14.1,17.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN2);
export default __webpack_public_path__ + "static/media/n2.50658efe49bd0ba201400ea4982674ad.svg";
export { ForwardRef as ReactComponent };